import {
	hasAskedToCompleteProfile,
	markAskedToCompleteProfile,
	missingCompleteProfileSteps,
} from "@domain/currentProfile/completeProfilePrompt";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { CompleteProfileModal } from "@ui/components/profile/completeProfileModal";
import { useModalTools } from "@ui/modals/modalContext";
import React, { useEffect } from "react";

export function useCompleteProfilePrompt(): void {
	const currentProfile = useCurrentProfile();
	const { createModal } = useModalTools();

	useEffect(() => {
		if (!currentProfile || hasAskedToCompleteProfile()) {
			return;
		}
		if (missingCompleteProfileSteps(currentProfile).length === 0) {
			return;
		}
		markAskedToCompleteProfile();
		createModal((close) => <CompleteProfileModal close={close} />);
	}, [createModal, currentProfile]);
}
